module.exports = __webpack_public_path__ + "static/media/N1.e9088331.png";